// extracted by mini-css-extract-plugin
module.exports = {"form":"DepositPaid_style_form__dWkWL"};